class EmptyPayload {} //NOSONAR

export default EmptyPayload;
